import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { cobotColours } from "../../theme/theme";
import api from "../../services/api";


import Header from "../../components/Header";
import RealTimeClock from "../../components/Time";
import UserImage from "../../components/UserImage";

const ClockOutPinPage = () => {
    const colors = cobotColours();
    const [numbers, setNumbers] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();

    const handleNumberClick = (number) => {
        if (numbers.length < 4) {
            const updatedNumbers = [...numbers, number];
            setNumbers(updatedNumbers);
            if (updatedNumbers.length === 4) {
                handleConfirm(updatedNumbers);
            }
        }
    };

    const handleBackspace = () => {
        setNumbers(numbers.slice(0, -1));
    };

    const handleConfirm = async (pin) => {
        try {
            // Reuse the same PIN validation endpoint
            const data = await api.auth.validateEmployee(id, pin.join(""));

            if (data.success) {
                console.log("PIN Validated for Clock-Out");
                // Navigate to ClockOutPhoto page, pass employeeId (already in id param)
                navigate(`/ClockOutPhoto/${id}`);
            } else {
                console.log("Incorrect PIN for Clock-Out");
                setNumbers(""); // Clear PIN input
                // Optionally, add user feedback here (e.g., a toast notification)
            }
        } catch (error) {
            console.error("Error validating PIN for Clock-Out:", error);
            setNumbers(""); // Clear PIN input on error
        }
    };

    return (
        <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            backgroundColor={colors.primary.special}
            padding={2}
        >
            {/* Header Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                backgroundColor={colors.primary.teal}
            >
                <Header title="ENTER YOUR PIN TO CLOCK OUT" />
            </Box>

            {/* Main Content */}
            <Box flex={1} display="flex" padding="10px 0" gap={2}>
                {/* Left Panel */}
                <Box width={{ xs: "100%", md: "25%" }} display="flex" flexDirection="column" gap={2}>
                    <Box
                        width="100%"
                        height="100px"
                        borderRadius="10px"
                        backgroundColor={colors.grey.lighter}
                        display="flex" justifyContent="center"
                        alignItems="center"
                    >
                        <RealTimeClock />
                    </Box>
                    <Box
                        flex={0.5}
                        borderRadius="10px"
                        textAlign="center"
                        backgroundColor={colors.grey.lighter}
                        display="flex"
                        justifyContent="center"
                        flexDirection="column"
                        alignItems="center"
                    >
                        <UserImage />
                        <Typography> This is my name</Typography>
                    </Box>
                </Box>

                {/* Right Panel */}
                <Box flex={1} display="flex" flexDirection="column" gap={2}>
                    {/* Clock Out Pin */}
                    <Box flex={1} overflow="hidden">
                        <Box
                            width={{ xs: "100vw", md: "65vw" }}
                            height={{ xs: "50vh", md: "50vh" }}
                        >
                            {/* Display entered numbers */}
                            <Box
                                display="flex"
                                justifyContent="center"
                                margin="30px 0"
                            >
                                {[0, 1, 2, 3].map((index) => (
                                    <Box
                                        key={index}
                                        width="30px"
                                        height="30px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        fontSize="20px"
                                        margin="5px"
                                        border="none"
                                        sx={{
                                            backgroundColor: colors.grey.lighter,
                                            borderRadius: "90%",
                                            fontWeight: "bold",
                                            color: colors.text.black,
                                        }}
                                    >
                                        {numbers[index] !== undefined ? "*" : ""}
                                    </Box>
                                ))}
                            </Box>

                            {/* Number input buttons */}
                            <Box width="100%" display="flex" justifyContent="center">
                                <Box display="flex" justifyContent="space-between" alignItems="center">

                                    {/* Number input buttons grid */}
                                    <Box
                                        display="grid"
                                        gridTemplateColumns="repeat(3, 80px)"
                                        gridTemplateRows="repeat(4, 80px)"
                                        gap="25px"
                                        justifyContent="center"
                                    >
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, "empty", 0, "back"].map((item, index) => (
                                            <Button
                                                key={index}
                                                sx={{
                                                    fontSize: item === "empty" ? "0px" : "25px", // Hide empty slot
                                                    fontWeight: "900",
                                                    margin: "5px",
                                                    color: colors.text.black,
                                                    backgroundColor: item === "empty" ? "transparent" : colors.grey.lighter,
                                                    borderRadius: "50%",
                                                    visibility: item === "empty" ? "hidden" : "visible",
                                                }}
                                                onClick={() => {
                                                    if (typeof item === "number") handleNumberClick(item);
                                                    if (item === "back") handleBackspace();
                                                }}
                                            >
                                                {item === "back" ? <BackspaceIcon fontSize="medium" /> : item}
                                            </Button>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                            <Box display="flex" justifyContent="center">
                                <Button 
                                    variant="outlined"
                                    color="secondary"
                                    sx={{mt: 4, width: "200px", padding: "10px"}}
                                    onClick={() => navigate(`/EmployeeClockedIn/${id}`)} // Go back if needed
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>



    );
};

export default ClockOutPinPage; 